import { render } from "./UiDropdown.vue?vue&type=template&id=fd8af11c&lang=pug"
import script from "./UiDropdown.vue?vue&type=script&lang=js"
export * from "./UiDropdown.vue?vue&type=script&lang=js"

import "./UiDropdown.vue?vue&type=style&index=0&id=fd8af11c&lang=sass"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__